<template>
    <li>
        <div class="menu-item-wrapper">
            <a
                class="root"
                :href="hasChildren ? null : menuLink"
                @click.prevent="handleClick"
            >
                <a
                    v-if="level === 0"
                    :href="menuLink"
                    class="unstyled-link"
                    @click.prevent.stop="handleClick($event, true)"
                >
                    <module-icon class="icon" :name="item.icon" />
                </a>
                <span class="label">{{ item.label }}</span>
            </a>

            <button class="btn-icon" @click.prevent="toggle" v-if="hasChildren">
                <i
                    class="fa fa-chevron-right chevron"
                    :class="{ open: open }"
                ></i>
            </button>
        </div>

        <transition name="expand">
            <ul class="menu-items" v-if="hasChildren && open">
                <side-menu-item
                    v-for="(child, index) in accessibleMenuItems(item.children)"
                    :key="index"
                    :item="child"
                    :level="level + 1"
                ></side-menu-item>
            </ul>
        </transition>
    </li>
</template>

<script>
import ModuleIcon from "@/module/layout/module-icon";
import item from "../../mixins/item";

export default {
    name: "SideMenuItem",
    components: {
        ModuleIcon
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            required: true
        },
        expandMenu: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false
        };
    },
    watch: {
        expandMenu(val) {
            this.open = val;
        }
    },
    computed: {
        hasChildren() {
            return this.item.children && this.item.children.length > 0;
        },
        menuLink() {
            return `/view${this.item.to}`;
        }
    },
    created() {
        const initialExpandedItems = this.$store.state.leftNavExpandedItems;

        if (this.hasChildren) {
            this.open = initialExpandedItems.includes(this.item.topMenuId);
        }
    },
    methods: {
        toggle() {
            this.open = !this.open;

            this.open
                ? this.$store.commit("addExpandedMenuItem", this.item.topMenuId)
                : this.$store.commit(
                      "removeExpandedMenuItem",
                      this.item.topMenuId
                  );
        },
        handleClick(event, iconClick = false) {
            if (this.hasChildren) {
                this.toggle();

                if (!iconClick) {
                    return;
                }
            }

            this._toggleEnhancedLayoutMobileSideMenu();

            if (this.$route.fullPath === this.item.to) {
                return;
            }

            this.$router.push(this.item.to);
        },
        accessibleMenuItems(item) {
            return item.filter(item => {
                const hasAccess = item.access
                    ? this._hasAccess(item.access)
                    : true;
                const isEnabled = item.isExtensionEnabled
                    ? this._isExtensionEnabled(item.isExtensionEnabled)
                    : true;

                return hasAccess && isEnabled;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.menu-item-wrapper {
    position: relative;
    background: none;
    color: white;
    border-radius: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
    }

    &:focus-visible {
        box-shadow: 0 0 0 0 #fff, 0 0 0 2px rgba(59, 130, 246, 0.5), 0 0 #0000;
    }

    &:focus-within,
    .router-link-exact-active {
        background: #c9ccde;
        border-radius: 5px;

        ::v-deep a,
        span {
            color: #190e30;
        }

        svg {
            fill: #190e30;
        }

        .chevron {
            color: #190e30;
        }
    }

    ::v-deep a,
    span {
        font-weight: 500;
        font-size: 1em;
        text-align: left;
        color: white;
        flex: 1;
    }

    svg {
        width: 18px;
        fill: white;
        flex-shrink: 0;
    }

    .chevron {
        text-align: right;
        transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);

        &.open {
            transform: rotate(90deg);
        }
    }
}

a.root {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    width: 100%;
    border: none;
    outline: none;
    cursor: pointer;
}

.menu-items {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;

    margin: 0 0 0 22px;
    padding: 4px 0 4px 4px;
    list-style: none;
    border-left: 1px solid #757575;
}

.btn-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: absolute;
    inset: 0 4px 0 auto;
    margin: auto 0;

    background: transparent;
    color: white;
    border: 0;
    border-radius: 50%;
    width: 22px;
    height: 22px;

    &:focus {
        outline: 0;
    }

    &:focus-visible {
        background: rgba(25, 14, 48, 0.1);
    }
}

.expand-enter-active,
.expand-leave-active {
    transition: max-height 400ms ease-in-out;
}

.expand-enter,
.expand-leave-to {
    max-height: 0;
}

.expand-enter-to,
.expand-leave {
    max-height: 500px;
}

.unstyled-link {
    all: unset !important;
    line-height: 0 !important;
    cursor: pointer !important;
}
</style>
